import sample from 'lodash/sample';

import { IconSettings, IconTypeEnum } from '@/types/schema';

export interface ColorPickerConfigType {
  color: string;
  hover: string;
}

export const COLOR_PICKER_LIST_CONFIG: ColorPickerConfigType[] = [
  { color: '#7278f5', hover: '#dbeafe' },
  { color: '#4c98fb', hover: '#dbeafe' },
  { color: '#28c870', hover: '#ccf5de' },
  { color: '#fbbf24', hover: '#fef3c7' },
  { color: '#f87171', hover: '#fee2e2' },
  { color: '#888888', hover: '#eaeaea' },
];

export const getIconSettingsWithRandomColor = (): IconSettings => ({
  type: IconTypeEnum.Color,
  value: (sample(COLOR_PICKER_LIST_CONFIG) || COLOR_PICKER_LIST_CONFIG[0]).color,
});

export const DEFAULT_ICON_SETTINGS_VALUE: IconSettings = {
  type: IconTypeEnum.Color,
  value: COLOR_PICKER_LIST_CONFIG[0].color,
};
